export const services = {
  WixSdk: Symbol('WixSdk'),
  global: Symbol('global'),
  collectionManager: Symbol('collectionManager'),
  collectionFetcher: Symbol('collectionFetcher'),
  siteStorage: Symbol('siteStorage'),
  collectionObservable: Symbol('collectionObservable'),
  widgetPlayer: Symbol('widgetPlayer'),
  experimentManager: Symbol('experimentManager'),
  settingsProvider: Symbol('settingsProvider'),
};
